import AvailabilityExportButton from "./_components/AvailabilityExportButton";

const Export = (props) => <AvailabilityExportButton {...props} />;

export default Export;
